import React, {useEffect, useRef, useState} from 'react';
import {Trans} from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import {toast} from 'react-toastify';
import _get from 'lodash/get';
import {useSelector} from 'react-redux';
import classnames from 'classnames';
import skincareProDao from '../../../../dao/skincareProDao';
import Loader from '../../../../components/spinner/Loader';
import useSkincare from '../../../../components/hook/useSkincare';

export default function PublishToOnlineModal({isShow, onPublish}) {
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {isV1} = useSkincare(auth);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const publishableRef = useRef(null);

  const getConfigStatus = async () => {
    setIsLoading(true);
    const scpUiConfigSetting = await skincareProDao.getCustomerSetting({
      type: 'ScpUiConfigSetting',
    });

    const currActionBtns = _get(
      scpUiConfigSetting,
      'editing_revision.data',
      {}
    );

    publishableRef.current = _get(currActionBtns, 'enable_publish', false);
    setIsLoading(false);
  };

  const handlePublish = async () => {
    await skincareProDao
      .publishCustomerSetting({
        type: 'ScpUiConfigSetting',
      })
      .then(res => {
        toast.success(
          <Trans i18nKey="p.s.uiconfiguration.publish.success">
            Your changes are being processed and will take a few minutes to
            apply. Please check the app later.
          </Trans>
        );
      })
      .catch(e => {
        toast.error(
          <Trans i18nKey="p.s.addoreditcategory.error.failed">Failed</Trans>
        );
      });
  };

  useEffect(() => {
    getConfigStatus();
  }, [isShow]);

  if (isLoading) {
    return <></>;
  }

  return (
    <Modal
      size="md"
      show={isShow}
      centered={true}
      onHide={() => onPublish(false)}
    >
      <Modal.Header closeButton={true}>
        <Modal.Title>
          <Trans i18nKey="p.s.uiconfiguration.saved">
            UI Configuration Saved
          </Trans>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Trans i18nKey="p.s.uiconfiguration.publish.desc">
            Your changes have been successfully saved.
          </Trans>
          <br />
          <br />
          <Trans i18nKey="p.s.uiconfiguration.publish.desc3">
            To make your settings visible in the app, please remember to publish
            them.
          </Trans>
          <br />
          <br />
          {_get(publishableRef, 'current', false) ? (
            <>
              <Trans i18nKey="p.s.uiconfiguration.publish.desc4">
                Would you like to publish now?
              </Trans>
              <br />
              <br />
              <p className="text-muted">
                <Trans i18nKey="p.s.uiconfiguration.publish.desc5">
                  (Note: This will publish all UI configurations and may take up
                  to 30 minutes. The App Preview QR code will also be updated.)
                </Trans>
              </p>
            </>
          ) : isV1 ? (
            <p className="text-danger">
              <Trans i18nKey="p.s.uiconfiguration.publishing.desc4.v1">
                Note: Publishing is temporarily unavailable because a Publish
                task is still running.
              </Trans>
            </p>
          ) : (
            <p className="text-danger">
              <Trans i18nKey="p.s.uiconfiguration.publishing.desc4.v2">
                Note: Publishing is temporarily unavailable because an App
                Preview QR Code Generation or Publish task is still running.
              </Trans>
            </p>
          )}
        </div>
      </Modal.Body>
      {_get(publishableRef, 'current', false) ? (
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary kt-margin-r-10"
            onClick={() => onPublish(false)}
          >
            <Trans i18nKey="p.p.s.view.later">Later</Trans>
          </button>
          <button
            type="button"
            disabled={isSubmitting}
            className={classnames({
              btn: true,
              'btn-primary': true,
              'kt-spinner': true,
              'kt-spinner-v2': true,
              'kt-spinner--center': true,
              'kt-spinner--sm': true,
              'kt-spinner--warning': isSubmitting,
            })}
            onClick={async () => {
              setIsSubmitting(true);
              await handlePublish();
              await onPublish(true);
              setIsSubmitting(false);
            }}
          >
            <Trans i18nKey="p.s.uiconfiguration.publish.online">
              Publish to Online
            </Trans>
          </button>
        </Modal.Footer>
      ) : (
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary kt-margin-r-10"
            onClick={() => onPublish(false)}
          >
            <Trans i18nKey="account.has.been.blocked.ok">OK</Trans>
          </button>
        </Modal.Footer>
      )}
    </Modal>
  );
}
